import { ApolloError } from "@apollo/client";
import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import React from "react";
import { FieldErrors, FieldValues } from "react-hook-form";

  const getFormErrorMessage = (name: keyof FieldValues, errors: FieldErrors<FieldValues>) => {
    return errors[name] ? <small className="p-error">{errors[name]?.message as string}</small> : <small className="p-error">&nbsp;</small>;
  }

  const successToaster = (msg: string) => easasAlert({
    severity: "success",
    summary: "Success",
    detail: msg,
    life: 2000,
  });

  const errorToaster = (err: ApolloError) => {
    easasAlert({ severity: "error", summary: "Error", detail: err.message, life: 3000 });
  };

  export { getFormErrorMessage, successToaster, errorToaster }